import { guestIntakePath, registrationAttributionFromSearchParams } from '../constants/guestIntake';
import { routes } from '../routes/routes';
import { LoggedUser } from '../models/Person';

export function defaultAuthenticatedPath(
  user: LoggedUser,
  eventIntakeEnabled: boolean,
  searchParams?: URLSearchParams,
): string {
  if (user.isAdmin) {
    return routes.ADMIN_DASHBOARD;
  }
  if (eventIntakeEnabled && user.isGuest) {
    if (searchParams && !user.guestIntakeCompleted) {
      const attribution = registrationAttributionFromSearchParams(searchParams);
      if (attribution.source || attribution.profileId) {
        return guestIntakePath(attribution);
      }
    }
    if (!user.guestIntakeCompleted) {
      return routes.GUEST_INTAKE;
    }
    return routes.DASHBOARD;
  }
  return routes.DASHBOARD;
}
